import { render, staticRenderFns } from "./TaskMap.vue?vue&type=template&id=0b9216e4"
import script from "./TaskMap.vue?vue&type=script&lang=ts"
export * from "./TaskMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports